import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { SessionService } from '../auth/session.service';
import { UserProfile } from './../../models/user/user-profile.model';
import { MenuItemModel } from '../../models/analytics/menu-item-model';
import { CommonService } from 'src/app/core/services/common/common.service';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  libraryMenu: Array<MenuItemModel>;
  loggedInUser: UserProfile;
  isUrlPermission: boolean;

  constructor(
    private sessionService: SessionService,
    private analyticsService: AnalyticsService,
    private commonService: CommonService,
    private router: Router
  ) {
    this.libraryMenu = [];
    this.loggedInUser = new UserProfile();
    this.isUrlPermission = false;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const accessToken = this.sessionService.getAccessToken() as any;
    if (accessToken) {
      this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
        const userAccessToken = result;
        if (!userAccessToken) {
          this.router.navigate(['/auth-callback'], {
            queryParams: { returnUrl: state.url },
          });
        } else {
          this.commonService.isNavbarShow =
            (state.url === '/help' || state.url === '/privacy-policy') ? false : true;
          //const subUrl = state.url.substr(1, 13);
          const subUrl = state.url.slice(1, 13);
          if (subUrl === 'action-detail' || subUrl === 'change-detail') {
            this.checkRoutePermission(subUrl, userAccessToken);
            return true;
          } else if (
            state.url.indexOf('/change-viewer/regulation-library/') >= 0 ||
            state.url.indexOf('/self-assessment/details/') >= 0 ||
            state.url.indexOf('/impact-assessment/details/') >= 0 ||
            state.url.indexOf('/impact-assessment/outcome/') >= 0 ||
            state.url === '/help' || state.url === '/privacy-policy' || state.url === '/publish-report'
          ) {
            return true;
          } else if (
            state.url.indexOf('/rule-detail?id=') > 0
          ) {
            this.checkRoutePermission('/rule-detail', userAccessToken);
            return true;
          } else {
            this.checkRoutePermission(state.url, userAccessToken);
          }
        }
      });
    } else {
      this.router.navigate(['/auth-callback'], {
        queryParams: { returnUrl: state.url },
      });
    }
    return of(true);
  }
  
  customEncodeURIComponent(input: string): string {
    let encoded = encodeURIComponent(input);
    encoded = encoded.replace(/!/g, '%21')
                     .replace(/\*/g, '%2A')
                     .replace(/'/g, '%27')
                     .replace(/\(/g, '%28')
                     .replace(/\)/g, '%29');
    return encoded;
}  

  checkRoutePermission(currentUrl: string, userAccessToken: UserProfile): void {
    //currentUrl = currentUrl.substr(1, currentUrl.length - 1);
    // Route permission fix for for special characters
    // Split the url and get the last element
    let urlArray = currentUrl.split('/');
    let finalPath = urlArray[urlArray.length - 1];
    // Decode then Encode the last element
    finalPath = decodeURIComponent(finalPath);
    finalPath = this.customEncodeURIComponent(finalPath);
    // Replace the last element with encoded value
    urlArray[urlArray.length - 1] = finalPath;
    // Join the array to get the final url
    currentUrl = urlArray.join('/');

    let changeDetailUrl:string = '';
    if (currentUrl[currentUrl.length - 1] === '/') {  
      currentUrl = currentUrl.slice(1, currentUrl.length-1);
    }
    
    if (userAccessToken.roleId > 0) {
      if (!currentUrl) {
        this.router.navigate(['/' + userAccessToken.landingPage]);
      }
      if (localStorage.getItem('libraryMenu' + userAccessToken.roleId + 'xhr')) {
        this.libraryMenu = JSON.parse(
          localStorage.getItem('libraryMenu' + userAccessToken.roleId + 'xhr') as string
        );
        if(this.libraryMenu && this.libraryMenu.length>0){
          if(currentUrl.indexOf('change-detail') > -1){
            changeDetailUrl = 'change-detail';
            this.isUrlPermission = this.libraryMenu.find(
              (a) => a.screenUrl.indexOf(changeDetailUrl) > -1 && a.parentId != null
            )
              ? true
              : false;
          }
          else{
            this.isUrlPermission = this.libraryMenu.find(
              (a) => a.screenUrl.indexOf(currentUrl) > -1 && a.parentId != null
            )
              ? true
              : false;
          }
          if (!this.isUrlPermission) {
            this.router.navigate(['/' + userAccessToken.landingPage]);
          }
        }
        else{
          this.getLibrary(userAccessToken,currentUrl);
        }
      } else {
        this.getLibrary(userAccessToken,currentUrl);
      }
    }
  }
  
  getLibrary(userAccessToken:any,currentUrl:any){
    this.analyticsService.getLibraryMenu().subscribe((data: MenuItemModel[]) => {
      localStorage.setItem('libraryMenu' + userAccessToken.roleId + 'xhr', JSON.stringify(data));
      this.isUrlPermission = data.find((a) => a.screenUrl.indexOf(currentUrl) > -1 && a.parentId != null) ? true : false;
      if (!this.isUrlPermission) {
        this.router.navigate(['/' + userAccessToken.landingPage]);
      }
    });
  }
  
}

